import React, {useEffect, useState} from "react";
import styled from "styled-components";
import MainVideo from "../components/atoms/MainVideo";
import VideoInfoBox from "../components/molecules/VideoInfoBox";
import BottomContents from "../components/molecules/BottomContents";
import Popup from "../components/templates/Popup";
import Cookies from "js-cookie";
import HomeContents from "../components/organisms/HomeContents";
import {device} from "../assets/styles/media";
import TabHomeContents from "../components/organisms/TabHomeContents";
import {useMediaQuery} from "react-responsive";
import request from "../config/Axios";

const Container = styled.div`
    width: 100%;
    height: 100%;
    //overflow-x: hidden;
`;

const PopContainer = styled.div`
    display: flex;
    max-width: 100%;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    justify-content: center;
    gap: ${(props)=>props.popCnt < 5 ? '30px' : '0'};
    padding-top: 80px;
    left: 0;
    z-index: 499;


    ${device.tablet} {
        max-width: 100vw;
        width: 100%;
        margin: 0 auto;
        display: block;
    }

`;
const VisualArea = styled.div`
    position: relative;
    max-height: calc(100vh - 20vh);
    padding-top: 80px;
    overflow: hidden;

    ${device.tablet} {
        padding-top: 5vw;
        height: auto;
        overflow: visible;
        margin-bottom: 100px;
    }

    ${device.mobile} {
        padding-top: 58px;
    }
`;

const Home = () => {
        const isTablet = useMediaQuery({maxWidth: 1023});
        const [popList, setPopList] = useState([]);
        const [popCnt, setPopCnt] = useState(0);
        const [dayOffData, setDayOffData] = useState({});
        const [closedPopups, setClosedPopups] = useState([]);

        const [subList, setSubList] = useState([]);
        const visiblePops = popList.filter(
            (pop) =>
                Cookies.get(`pop-${pop.idx}`) !== 'hidden' && !closedPopups.includes(pop.idx + "")
        );
        const contentsList = [
            {title: "알림", link: "/notice", subList : subList},
            {title: "관람",  link: "/map"},
            {title: "전시",  link: "/program/museum"},
            {title: "이벤트", link: "/program/special"},
        ];

        useEffect(() => {
            (async () => {
                try {
                    const popupResponse = await request.get(`popup`);
                    let data = popupResponse?.data?.data.length > 5 ? popupResponse?.data?.data.slice(0,5) : popupResponse?.data?.data;
                   // let data = [
                   //     {
                   //         "hyperlink": "https://rdev.dforest.co.kr/map/foodcourt",
                   //         "width": 400,
                   //         "idx": 564,
                   //         "title": "베이커리",
                   //         "content": img,
                   //         "height": 400
                   //     },
                   //     {
                   //         "hyperlink": "https://map.naver.com/p/search/%EA%B0%95%EC%95%84%EC%A7%80%EC%88%B2/place/1806671210?lng=127.6620201&lat=37.7364351&placePath=/ticket?bookingRedirectUrl=https://m.booking.naver.com/booking/5/bizes/434118&from=map&fromPanelNum=2&timestamp=202506131052&locale=ko&svcName=map_pcv5&searchText=%EA%B0%95%EC%95%84%EC%A7%80%EC%88%B2&from=map&fromPanelNum=2&timestamp=202505301415&locale=ko&svcName=map_pcv5&searchText=%EA%B0%95%EC%95%84%EC%A7%80%EC%88%B2&theme=place&entry=pll&area=pll&c=15.00,0,0,0,dh",
                   //         "width": 400,
                   //         "idx": 565,
                   //         "title": "6월프로모션_수정",
                   //         "content": img2,
                   //         "height": 400
                   //     },
                   //
                   //     {
                   //         "hyperlink": "",
                   //         "width": 400,
                   //         "idx": 577,
                   //         "title": "uuuuuuu",
                   //         "content": img3,
                   //         "height": 400
                   //     }
                   // ]
                    setPopList(data);
                    // setPopCnt(3);
                    setPopCnt(popupResponse?.data?.data?.length);
                } catch (err) {
                    console.error('api 호출 중 에러 발생:', err);
                }

                try {
                    const today = new Date();
                    const formatted = today.toISOString().split('T')[0];
                    const dayOffResponse = await request.get(`dayoff/${formatted}`);
                    setDayOffData(dayOffResponse?.data?.data);
                } catch (err) {
                    console.error('api 호출 중 에러 발생: ', err);
                }

                try {
                    const latestResponse = await request.get(`main/latest`);
                    setSubList(latestResponse?.data?.data);
                } catch (err) {
                    console.error('api 호출 중 에러 발생:', err);
                }
            })();
        }, []);

        return (
            <>
                <Container>
                    {/* popup*/}
                    {visiblePops.length > 0 &&  (
                        <PopContainer popCnt={popCnt}>
                            {visiblePops.map((pop) => (
                                <Popup key={pop.idx}
                                       pop={pop}
                                       setClosedPopups={setClosedPopups}
                                       popCnt={popCnt}
                                       setPopCnt={setPopCnt}
                                />
                            ))}
                        </PopContainer>
                    )}
                    {/*video 배너 부분*/}
                    <VisualArea>
                        <MainVideo/>
                        <VideoInfoBox dayOffData={dayOffData} />
                    </VisualArea>
                    {/*  알림, 공지, 전시, 이벤트 */}
                    {!isTablet ? <HomeContents list={contentsList}/>
                        : <TabHomeContents list={contentsList}/>
                    }

                    {/*    자연을 담은 강아지숲 이야기  */}
                    <BottomContents/>
                </Container>
            </>
        );
    }
;

export default Home;
